"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListFilesResponse = void 0;
var file_descriptor_1 = require("../metadata/file-descriptor");
/**
 * List Files Response
 * @doc ListFilesResponse
 */
var ListFilesResponse = /** @class */ (function () {
    function ListFilesResponse(data) {
        this.files = [];
        this.nextPageToken = data.nextPageToken;
        this.files = data.files.map(function (file) {
            return new file_descriptor_1.FileDescriptor(file);
        });
    }
    return ListFilesResponse;
}());
exports.ListFilesResponse = ListFilesResponse;
//# sourceMappingURL=list-files-response.js.map